<template>
  <div class="container_map">
    <b-container fluid>
      <!--b-row class="header_map">
        <div class="col-2" style="line-height:40px;font-weight:500;font-size:16px;">
          <div @click="gotToPath('/home')" style="cursor:pointer;margin-top:30px;">
            <font-awesome-icon style="font-size:24px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['far', 'chevron-left']"/>
          </div>
        </div>
        <div class="col-10" style="padding:15px 10px;font-weight:500;font-size:12px;color:#ffffff;">
          <template v-if="selectedCompany.delivery_retrieve">
          Entrega: {{selectedCompany.delivery_retrieve}} -
          </template>
          <template v-if="selectedCompany.delivery_taking">
          Retirada: {{selectedCompany.delivery_taking}} <br/>
          </template>
          <template v-if="selectedCompany.delivery_add_info">
          {{selectedCompany.delivery_add_info}}
          </template>
        </div>
      </b-row -->
      <HeaderBackMobile :noCart='true' />
    </b-container>
    <b-container fluid>
      <b-row v-if="fretes.length" class="legend" style="font-size:16px; ">
        <b-col cols="12" style="height:30px;font-weight:500;"><font-awesome-icon style="color:red;font-size:18px;" :icon="['fas', 'truck']"/> Entrega</b-col>
        <b-col cols="12">
          <b-row v-for="(frete, idx) in fretes" v-bind:key="idx" style="margin-bottom:7px;">
            <div class="col-3" :style="{backgroundColor: frete.color}" style="height:20px;opacity:0.4;"></div>
            <div v-if="!selectedCompany.show_inmap_price"  class="col-9" style="height:20px;">área {{idx + 1}}</div>
            <div v-else class="col-9">R$ {{formatPrice(frete.price)}}
              <template v-if="selectedCompany.show_inmap_estimate">
                <br/><div style="margin-left:-47px;font-size:14px;margin-top:-3px;">Previsão {{frete.estimation}} dia(s)</div>
              </template>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="showRetrieve()" cols="12" style="margin-top:8px;height:30px;font-weight:500;">
          <font-awesome-icon style="color:red;font-size:20px;" :icon="['fas', 'map-marker-alt']"/> Retirada
        </b-col>
      </b-row>
    </b-container>
    <div id="map"></div>


    <Modal :showModal="modalInfos" >
      <div @click="modalInfos = false" style="z-index:19002;position:absolute;top:5px;right:5px;cursor:pointer;width:30px;height:30px;text-align:center;">
        <font-awesome-icon style="font-size:26px;cursor:pointer;" :style="{color: getCssColor('primary_bt')}" :icon="['fal', 'times']"/>
      </div>
      <div style="width:100%; height:100%;padding:10px;overflow:auto;">
        <b-container>
         <div class="col-12" style="padding:15px 0;font-size:15px;text-align:justify;">
           <b> Informações de Entrega </b><br/><br/>
            <template v-if="selectedCompany.delivery_retrieve && selectedCompany.delivery_retrieve.length > 1">
            <b>Entrega:</b> {{selectedCompany.delivery_retrieve}} <br/><br/>
            </template>
            <template v-if="selectedCompany.delivery_taking && selectedCompany.delivery_taking.length > 1">
            <b>Retirada:</b> {{selectedCompany.delivery_taking}} <br/><br/>
            </template>
            <template v-if="selectedCompany.delivery_add_info">
              {{selectedCompany.delivery_add_info}}
            </template>
          </div>
        </b-container>
      </div>
    </Modal>
  </div>
</template>

<script>
/* global google */
import navigation from '@/mixins/navigation'
import colors from '@/mixins/colors'
import formaters from '@/mixins/formaters'
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import Modal from '@/components/Modal'

export default {
  name: "Map",
  data () {
    return {
      map: null,
      fretes: [],
      selectedCompany: null,
      modalInfos: false
    }
  },
  mixins: [navigation, colors, formaters],

  components: {HeaderBackMobile, Modal},

  created () {
    this.selectedCompany = (this.$store.state.choicedCompany ? this.$store.state.choicedCompany : this.$store.state.company)
    if (this.selectedCompany.delivery_retrieve || this.selectedCompany.delivery_taking || this.selectedCompany.delivery_add_info) {
      this.modalInfos = true
    }
  },

  mounted () {
    let vm = this
    let center = {lat: -10.234242, lng: -48.3293567}
    if (this.selectedCompany.pinAdresses.length) {
      center = {lat: Number(this.selectedCompany.pinAdresses[0].lat),
         lng: Number(this.selectedCompany.pinAdresses[0].lng)}
    } else if (this.selectedCompany.adresses.length) {
      center = {lat: this.selectedCompany.adresses[0].coordinates[1],
         lng: this.selectedCompany.adresses[0].coordinates[0]}
    }

    let colors = [
"#63b598", "#ce7d78", "#648177" ,"#0d5ac1" ,
"#f205e6" ,"#1c0365" ,"#14a9ad" ,"#4ca2f9" ,"#a4e43f" ,"#d298e2" ,"#6119d0",
"#d2737d" ,"#c0a43c" ,"#f2510e" ,"#651be6" ,"#79806e" ,"#61da5e" ,"#cd2f00" ,
"#9348af" ,"#01ac53" ,"#c5a4fb" ,"#996635","#b11573" ,"#4bb473" ,"#75d89e" ,
"#2f3f94" ,"#2f7b99" ,"#da967d" ,"#34891f" ,"#b0d87b" ,"#ca4751" ,"#7e50a8" ,
"#c4d647" ,"#e0eeb8" ,"#11dec1" ,"#289812" ,"#566ca0" ,"#ffdbe1" ,"#2f1179" ,
"#935b6d" ,"#916988" ,"#513d98" ,"#aead3a", "#9e6d71", "#4b5bdc", "#0cd36d",
"#250662", "#cb5bea", "#228916", "#ac3e1b", "#df514a", "#539397", "#880977",
"#f697c1", "#ba96ce", "#679c9d", "#c6c42c", "#5d2c52", "#48b41b", "#e1cf3b",
"#5be4f0", "#57c4d8", "#a4d17a", "#225b8", "#be608b", "#96b00c", "#088baf",
"#f158bf", "#e145ba", "#ee91e3", "#05d371", "#5426e0", "#4834d0", "#802234",
"#6749e8", "#0971f0", "#8fb413", "#b2b4f0", "#c3c89d", "#c9a941", "#41d158",
"#fb21a3", "#51aed9", "#5bb32d", "#807fb", "#21538e", "#89d534", "#d36647",
"#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3",
"#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", "#b2be57", "#fa06ec",
"#1bb699", "#6b2e5f", "#64820f", "#1c271", "#21538e", "#89d534", "#d36647",
"#7fb411", "#0023b8", "#3b8c2a", "#986b53", "#f50422", "#983f7a", "#ea24a3",
"#79352c", "#521250", "#c79ed2", "#d6dd92", "#e33e52", "#b2be57", "#fa06ec",
"#1bb699", "#6b2e5f", "#64820f", "#1c271", "#9cb64a", "#996c48", "#9ab9b7",
"#06e052", "#e3a481", "#0eb621", "#fc458e", "#b2db15", "#aa226d", "#792ed8",
"#73872a", "#520d3a", "#cefcb8", "#a5b3d9", "#7d1d85", "#c4fd57", "#f1ae16",
"#8fe22a", "#ef6e3c", "#243eeb", "#1dc18", "#dd93fd", "#3f8473", "#e7dbce",
"#421f79", "#7a3d93", "#635f6d", "#93f2d7", "#9b5c2a", "#15b9ee", "#0f5997",
"#409188", "#911e20", "#1350ce", "#10e5b1", "#fff4d7", "#cb2582", "#ce00be",
"#32d5d6", "#17232", "#608572", "#c79bc2", "#00f87c", "#77772a", "#6995ba",
"#fc6b57", "#f07815", "#8fd883", "#060e27", "#96e591", "#21d52e", "#d00043",
"#b47162", "#1ec227", "#4f0f6f", "#1d1d58", "#947002", "#bde052", "#e08c56",
"#28fcfd", "#bb09b", "#36486a", "#d02e29", "#1ae6db", "#3e464c", "#a84a8f",
"#911e7e", "#3f16d9", "#0f525f", "#ac7c0a", "#b4c086", "#c9d730", "#30cc49",
"#3d6751", "#fb4c03", "#640fc1", "#62c03e", "#d3493a", "#88aa0b", "#406df9",
"#615af0", "#4be47", "#2a3434", "#4a543f", "#79bca0", "#a8b8d4", "#00efd4",
"#7ad236", "#7260d8", "#1deaa7", "#06f43a", "#823c59", "#e3d94c", "#dc1c06",
"#f53b2a", "#b46238", "#2dfff6", "#a82b89", "#1a8011", "#436a9f", "#1a806a",
"#4cf09d", "#c188a2", "#67eb4b", "#b308d3", "#fc7e41", "#af3101", "#ff065",
"#71b1f4", "#a2f8a5", "#e23dd0", "#d3486d", "#00f7f9", "#474893", "#3cec35",
"#1c65cb", "#5d1d0c", "#2d7d2a", "#ff3420", "#5cdd87", "#a259a4", "#e4ac44",
"#1bede6", "#8798a4", "#d7790f", "#b2c24f", "#de73c2", "#d70a9c", "#25b67",
"#88e9b8", "#c2b0e2", "#86e98f", "#ae90e2", "#1a806b", "#436a9e", "#0ec0ff",
"#f812b3", "#b17fc9", "#8d6c2f", "#d3277a", "#2ca1ae", "#9685eb", "#8a96c6",
"#dba2e6", "#76fc1b", "#608fa4", "#20f6ba", "#07d7f6", "#dce77a", "#77ecca"]


    let zoom = 12
    if (this.selectedCompany.in_map_zoom) {
      zoom = Number(this.selectedCompany.in_map_zoom)
    }
    this.map = new google.maps.Map(document.getElementById('map'), {
      zoom: zoom,
      center: center,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    })

    this.selectedCompany.pinAdresses.forEach((pin) => {
      if (pin.retrieve === true || pin.retrieve === 'true')
      new google.maps.Marker({
        position: {lat: Number(pin.lat), lng: Number(pin.lng)},
        map: vm.map,
        title: vm.selectedCompany.shortName
      })
    })

    let i = -1
    this.selectedCompany.adresses.forEach((addr) => {
      let outerCoords = []
      addr.coordinates.forEach((coord) => {
        outerCoords.push({lat: coord[1], lng: coord[0]})
      })
      i++
      if (i > colors.length) {
        i = 0
      }
      if (addr.kmlPrice !== null) {
        this.fretes.push({color: colors[i], price: addr.kmlPrice, estimation: addr.estimation})
      }
      this.map.data.add({geometry: new google.maps.Data.Polygon([outerCoords])})
    })

    let ic = -1
    this.map.data.setStyle(() => {
      ic++
      if (ic > colors.length) {
        ic = 0
      }
      return {
        fillColor: colors[ic],
        strokeWeight: 0
      }
    })
  },

  methods: {
    showRetrieve () {
      return this.selectedCompany.pinAdresses.filter(pin => pin.retrieve === true || pin.retrieve === 'true').length > 0
    }
  }

}
</script>

<style lang="scss">
.legend {
  position:absolute;
  width:140px;
  top:120px;
  left:10px;
  z-index:10000;
  box-shadow: 1px 1px 1px rgba(0,0,0,0.3);
  border-radius: 2px;
  background-color: #ffffff;
  padding:5px
}

#map {
  height:calc( 100% - 70px);
}

.container_map {
  width: 100vw;
  height: calc(100vh - 15px);
  background-color: #2C2A29;
  position: relative;
}
</style>
